import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  lifecycle,
  setPropTypes,
  withProps,
  withState,
} from 'recompose';
import appActions from 'state/app/actionCreators';
import authSelectors from 'state/auth/selectors';
import App from 'pages/App/component';

const enhance = compose(
  connect(
    (state) => ({
      userIsLogged: authSelectors.userIsLogged(state),
      isAuthenticating: authSelectors.isAuthenticating(state),
    }),
    {
      initApp: appActions.initApp,
    }
  ),
  withState('isInitializing', 'setIsInitializing', true),
  lifecycle({
    componentDidMount() {
      const { initApp, userIsLogged, setIsInitializing } = this.props;

      if (userIsLogged) {
        initApp();
      }
      setIsInitializing(false);
    },
  }),
  withProps(({ isAuthenticating, isInitializing }) => ({
    isLoading: isAuthenticating || isInitializing,
  })),
  setPropTypes({
    initApp: PropTypes.func.isRequired,
  })
);

export default enhance(App);
